const translationKeys = {
  property_property_container_header_title:
    'property_property_container_header_title',
  property_breadcrumb_property: 'property_breadcrumb_property',
  property_breadcrumb_first_property_calculator:
    'property_breadcrumb_first_property_calculator',
  property_mortgage_calculator_title: 'property_mortgage_calculator_title',
  property_mortgage_calculator_subtitle:
    'property_mortgage_calculator_subtitle',
  property_mortgage_calculator_tab_option_alone:
    'property_mortgage_calculator_tab_option_alone',
  property_mortgage_calculator_tab_option_with_others:
    'property_mortgage_calculator_tab_option_with_others',
  property_mortgage_calculator_buy_alone_radio_button:
    'property_mortgage_calculator_buy_alone_radio_button',
  property_mortgage_calculator_buy_with_others_radio_button:
    'property_mortgage_calculator_buy_with_others_radio_button',
  property_mortgage_calculator_calculation_purchase_amount:
    'property_mortgage_calculator_calculation_purchase_amount',
  property_mortgage_calculator_calculation_monthly_payment_amount:
    'property_mortgage_calculator_calculation_monthly_payment_amount',
  property_mortgage_calculator_calculation_monthly_payment:
    'property_mortgage_calculator_calculation_monthly_payment',
  property_mortgage_calculator_calculation_graph_label:
    'property_mortgage_calculator_calculation_graph_label',
  property_mortgage_calculator_calculation_graph_bullet_one:
    'property_mortgage_calculator_calculation_graph_bullet_one',
  property_mortgage_calculator_calculation_graph_bullet_two:
    'property_mortgage_calculator_calculation_graph_bullet_two',
  property_mortgage_calculator_tips_title:
    'property_mortgage_calculator_tips_title',
  property_mortgage_calculator_tips_subtitle:
    'property_mortgage_calculator_tips_subtitle',
  property_mortgage_calculator_information_equity_title:
    'property_mortgage_calculator_information_equity_title',
  property_mortgage_calculator_information_equity_text_one:
    'property_mortgage_calculator_information_equity_text_one',
  property_mortgage_calculator_information_equity_text_two:
    'property_mortgage_calculator_information_equity_text_two',
  property_mortgage_calculator_information_equity_needed_title:
    'property_mortgage_calculator_information_equity_needed_title',
  property_mortgage_calculator_information_equity_needed_text:
    'property_mortgage_calculator_information_equity_needed_text',
  property_mortgage_calculator_information_loan_amount_title:
    'property_mortgage_calculator_information_loan_amount_title',
  property_mortgage_calculator_information_loan_amount_text:
    'property_mortgage_calculator_information_loan_amount_text',
  property_mortgage_calculator_information_loan_amount_credit_title:
    'property_mortgage_calculator_information_loan_amount_credit_title',
  property_mortgage_calculator_information_loan_amount_credit_text:
    'property_mortgage_calculator_information_loan_amount_credit_text',
  property_mortgage_calculator_information_price_example_title:
    'property_mortgage_calculator_information_price_example_title',
  property_mortgage_calculator_information_price_example_text:
    'property_mortgage_calculator_information_price_example_text',
  property_mortgage_calculator_calculation_about_button:
    'property_mortgage_calculator_calculation_about_button',
  property_mortgage_calculator_about_title:
    'property_mortgage_calculator_about_title',
  property_mortgage_calculator_about_subtitle:
    'property_mortgage_calculator_about_subtitle',
  property_mortgage_calculator_about_bullet_one:
    'property_mortgage_calculator_about_bullet_one',
  property_mortgage_calculator_about_bullet_two:
    'property_mortgage_calculator_about_bullet_two',
  property_mortgage_calculator_about_bullet_three:
    'property_mortgage_calculator_about_bullet_three',
  property_mortgage_calculator_tip_card_loan_checklist_title:
    'property_mortgage_calculator_tip_card_loan_checklist_title',
  property_mortgage_calculator_tip_card_loan_checklist_text:
    'property_mortgage_calculator_tip_card_loan_checklist_text',
  property_mortgage_calculator_tip_card_loan_checklist_button:
    'property_mortgage_calculator_tip_card_loan_checklist_button',
  property_mortgage_calculator_tip_card_equity_title:
    'property_mortgage_calculator_tip_card_equity_title',
  property_mortgage_calculator_tip_card_equity_text:
    'property_mortgage_calculator_tip_card_equity_text',
  property_mortgage_calculator_tip_card_equity_button:
    'property_mortgage_calculator_tip_card_equity_button',
  property_mortgage_calculator_tip_card_outside_city_title:
    'property_mortgage_calculator_tip_card_outside_city_title',
  property_mortgage_calculator_tip_card_outside_city_text:
    'property_mortgage_calculator_tip_card_outside_city_text',
  property_mortgage_calculator_tip_card_outside_city_button:
    'property_mortgage_calculator_tip_card_outside_city_button',
  property_mortgage_calculator_tip_card_talk_with_advicer_title:
    'property_mortgage_calculator_tip_card_talk_with_advicer_title',
  property_mortgage_calculator_tip_card_talk_with_advicer_text:
    'property_mortgage_calculator_tip_card_talk_with_advicer_text',
  property_mortgage_calculator_tip_card_talk_with_advicer_button:
    'property_mortgage_calculator_tip_card_talk_with_advicer_button',
  property_mortgage_calculator_tip_card_buy_with_a_friend_title:
    'property_mortgage_calculator_tip_card_buy_with_a_friend_title',
  property_mortgage_calculator_tip_card_buy_with_a_friend_text:
    'property_mortgage_calculator_tip_card_buy_with_a_friend_text',
  property_mortgage_calculator_tip_card_buy_with_a_friend_button:
    'property_mortgage_calculator_tip_card_buy_with_a_friend_button',
  property_mortgage_calculator_tip_card_buy_contract_tip_title:
    'property_mortgage_calculator_tip_card_buy_contract_tip_title',
  property_mortgage_calculator_tip_card_buy_contract_tip_text:
    'property_mortgage_calculator_tip_card_buy_contract_tip_text',
  property_mortgage_calculator_tip_card_buy_contract_tip_button:
    'property_mortgage_calculator_tip_card_buy_contract_tip_button',
  property_mortgage_calculator_input_alone:
    'property_mortgage_calculator_input_alone',
  property_mortgage_calculator_input_with_others:
    'property_mortgage_calculator_input_with_others',
  property_mortgage_calculator_link_card_borrowing_capacity_title:
    'property_mortgage_calculator_link_card_borrowing_capacity_title',
  property_mortgage_calculator_link_card_borrowing_capacity_description:
    'property_mortgage_calculator_link_card_borrowing_capacity_description',
  property_mortgage_calculator_link_card_borrowing_capacity_link:
    'property_mortgage_calculator_link_card_borrowing_capacity_link',
  property_mortgage_calculator_link_card_interest_rate_title:
    'property_mortgage_calculator_link_card_interest_rate_title',
  property_mortgage_calculator_link_card_interest_rate_description:
    'property_mortgage_calculator_link_card_interest_rate_description',
  property_mortgage_calculator_link_card_interest_rate_link:
    'property_mortgage_calculator_link_card_interest_rate_link',
  property_mortgage_calculator_link_card_pre_qualification_letter_title:
    'property_mortgage_calculator_link_card_pre_qualification_letter_title',
  property_mortgage_calculator_link_card_pre_qualification_letter_description:
    'property_mortgage_calculator_link_card_pre_qualification_letter_description',
  property_mortgage_calculator_link_card_pre_qualification_letter_link:
    'property_mortgage_calculator_link_card_pre_qualification_letter_link',
  property_mortgage_calculator_link_card_get_loan_offer_title:
    'property_mortgage_calculator_link_card_get_loan_offer_title',
  property_mortgage_calculator_link_card_get_loan_offer_description:
    'property_mortgage_calculator_link_card_get_loan_offer_description',
  property_mortgage_calculator_link_card_get_loan_offer_link:
    'property_mortgage_calculator_link_card_get_loan_offer_link',
  property_mortgage_calculator_calculation_equity_help_button_title:
    'property_mortgage_calculator_calculation_equity_help_button_title',
  property_mortgage_calculator_calculation_equity_help_button_text:
    'property_mortgage_calculator_calculation_equity_help_button_text',
  property_mortgage_calculator_info_message_low_results:
    'property_mortgage_calculator_info_message_low_results',
  property_mortgage_calculator_info_message_no_selected_values:
    'property_mortgage_calculator_info_message_no_selected_values',
};

Object.freeze(translationKeys);

export default translationKeys;
